/**
 * Registers the credit-request queue at `/requests`, order 20.
 *
 * Plain `createElement`, not JSX -- this file is `.ts`, matching every other
 * area's registration file (`src/ops/register/routes.ts`,
 * `src/ops/keys/routes.ts`, `../routes/index.ts`, `compose.ts`). Wrapped in
 * `OpsShell` here, not by the composed router, for the same reason
 * `register/routes.ts` is: access control is asked once per screen through
 * `useOpsEntitlement`, not decided by this file.
 */

import { Inbox } from 'lucide-react';
import { createElement } from 'react';

import { defineCatalogue } from '../../i18n';
import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { QueueRoute } from './Queue';

// Figma 153:342: the sidebar's own label reads "Pedidos", shorter than the
// page title ("Pedidos de crédito").
const catalogue = defineCatalogue({ navLabel: 'Pedidos' }, { navLabel: 'Requests' });

export const bundle: OpsRouteBundle = {
  order: 20,
  routes: [
    {
      path: '/requests',
      element: createElement(OpsShell, null, createElement(QueueRoute)),
      kind: 'data',
    },
  ],
  nav: [{ path: '/requests', label: () => catalogue.t('navLabel'), icon: Inbox, kind: 'data' }],
};
